import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="submit-handler"
export default class extends Controller {
  static targets = ["button", "loading"];

  static values = {
    showLoading: { type: Boolean, default: false },
  };

  declare readonly buttonTargets: HTMLButtonElement[];
  declare readonly hasLoadingTarget: boolean;
  declare readonly loadingTarget: HTMLElement;
  declare readonly showLoadingValue: boolean;

  connect(): void {}

  submit(event: Event): void {
    const submitEvent = event as SubmitEvent;
    const clickedButton = submitEvent.submitter as HTMLButtonElement | null;
    const form = this.element as HTMLFormElement;

    // クリックされたボタンのname属性とvalue属性を保持する隠しフィールドを追加
    if (clickedButton && clickedButton.name) {
      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = clickedButton.name;
      hiddenInput.value = clickedButton.value || "true";
      form.appendChild(hiddenInput);
    }

    // すべてのボタンを無効化（必須）
    this.buttonTargets.forEach((button) => {
      button.disabled = true;
    });

    // 「戻る」ボタン以外の場合のみローディング表示（オプション）
    if (this.showLoadingValue && this.hasLoadingTarget && (!clickedButton || clickedButton.name !== "back")) {
      this.loadingTarget.style.display = "block";
    }

    // フォーム送信を続行
    // ここでpreventDefault()を呼び出さないことが重要
  }
}
